<template>
  <div class="header">
    <div class="left-section">
      <div class="logo">
        <img src="@/assets/image/logo.png" alt="LOGO">
      </div>
      
      <div class="menu">
        <ul>
          <li v-for="item in menuItems" 
              :key="item.id"
              :class="{ active: currentPath === item.path }"
              @click="handleMenuClick(item)">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="right-section">
      <!-- 消息通知 -->
      <!-- <div class="notification">
        <el-badge :value="unreadCount" :max="99" v-if="unreadCount > 0">
          <el-dropdown trigger="click" @command="handleNotificationCommand">
            <span class="notification-icon">
              <i class="el-icon-bell"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="custom-notification-dropdown">
              <div class="notification-header">
                <span>消息通知</span>
                <el-button type="text" size="mini" @click.stop="markAllRead">全部已读</el-button>
              </div>
              <el-dropdown-item v-for="notice in notifications" 
                              :key="notice.id"
                              :class="{ 'unread': !notice.read }"
                              :command="notice.id"
                              class="notification-item">
                <div class="notice-item">
                  <div class="notice-content">
                    <div class="notice-title">{{ notice.title }}</div>
                    <div class="notice-time">{{ notice.time }}</div>
                  </div>
                </div>
              </el-dropdown-item>
              <div class="notification-footer">
                <el-button type="text" size="mini" @click.stop="viewAllNotifications">查看全部</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </el-badge>
        <span class="notification-icon" v-else @click="viewAllNotifications">
          <i class="el-icon-bell"></i>
        </span>
      </div> -->

      <!-- 用户信息 -->
      <div class="user-info">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <el-avatar :size="36" :src="userAvatar"></el-avatar>
            <span class="username">{{ username }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="profile">
              <i class="el-icon-user-solid"></i>个人信息
            </el-dropdown-item> -->
            <el-dropdown-item command="password">
              <i class="el-icon-lock"></i>修改密码
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <i class="el-icon-switch-button"></i>退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 添加修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :modal="false"
      :visible.sync="passwordDialogVisible"
      width="400px"
      @close="resetPasswordForm">
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px">
        <!-- <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password>
          </el-input>
        </el-form-item> -->
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPasswordChange" :loading="submitting">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from '@/api/case'

export default {
  name: 'Header',
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      currentPath: '',
      menuItems: [
        { id: 1, name: '工作台', path: '/index', icon: 'el-icon-monitor' },
        { id: 2, name: '案件', path: '/cases', icon: 'el-icon-folder' },
        { id: 3, name: '咨询', path: '/consulting', icon: 'el-icon-chat-line-round' },
        { id: 4, name: '合同', path: '/contracts', icon: 'el-icon-document' }
      ],
      username: this.$store.state.userInfo.real_name || '未知',
      userAvatar: this.$store.state.userInfo.avatar ,
      // 消息通知数据
      notifications: [
        {
          id: 1,
          type: 'case',
          title: '张某某案件有新进展',
          time: '10分钟前',
          read: false
        },
        {
          id: 2,
          type: 'system',
          title: '系统维护通知',
          time: '1小时前',
          read: false
        },
        {
          id: 3,
          type: 'message',
          title: '李律师给您发送了消息',
          time: '2小时前',
          read: false
        }
      ],
      // 添加修改密码相关数据
      passwordDialogVisible: false,
      submitting: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
       
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    unreadCount() {
      return this.notifications.filter(notice => !notice.read).length
    }
  },
  created() {
    this.currentPath = this.$route.path
  },
  methods: {
    handleMenuClick(item) {
      this.currentPath = item.path
      this.$router.push(item.path).catch(err => {
        console.log(err)
      })
    },
    // 处理下拉菜单命令
    handleCommand(command) {
      switch (command) {
        case 'profile':
          // 处理个人信息
          break;
        case 'password':
          this.passwordDialogVisible = true
          break;
        case 'logout':
          this.logout();
          break;
      }
    },
    
    // 退出登录
    logout() {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除用户信息
        this.$store.commit('clearUserInfo')
        // 清除 token
        localStorage.removeItem('token')
        // 跳转到登录页
        this.$router.push('/login')
        this.$message.success('已退出登录')
      }).catch(() => {})
    },
    // 获取通知图标
    getNoticeIcon(type) {
      const icons = {
        case: 'el-icon-document',
        system: 'el-icon-setting',
        message: 'el-icon-chat-dot-round'
      }
      return icons[type] || 'el-icon-info'
    },
    
    // 处理通知点击
    handleNotificationCommand(id) {
      const notice = this.notifications.find(n => n.id === id)
      if (notice) {
        notice.read = true
        // 这里可以添加跳转逻辑
        this.$message.success('已标记为已读')
      }
    },
    
    // 标记所有为已读
    markAllRead() {
      this.notifications.forEach(notice => {
        notice.read = true
      })
      this.$message.success('已全部标记为已读')
    },
    
    // 查看全部通知
    viewAllNotifications() {
      // 这里可以添加查看全部通知的逻辑
      console.log('查看全部通知')
    },

    // 重置密码表单
    resetPasswordForm() {
      this.$refs.passwordForm?.resetFields()
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },

    // 提交修改密码
    async submitPasswordChange() {
      if(this.passwordForm.newPassword != this.passwordForm.confirmPassword) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      if(this.passwordForm.newPassword.length < 6) {
        this.$message.error('密码长度不能小于6位')
        return
      }
      if(this.passwordForm.newPassword == '123456') {
        this.$message.error('新密码不能为123456')
        return
      }
      try {
        await this.$refs.passwordForm.validate()
        
        this.submitting = true
        console.log(this.passwordForm)
        const res = await changePassword({
          newpassword: this.passwordForm.newPassword
        })

        if (res.status === 200) {
          this.$message.success('密码修改成功，请重新登录')
          this.passwordDialogVisible = false
          // 退出登录
          this.$store.commit('clearUserInfo')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.message || '修改失败，请重试')
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: relative;
  width: 100%;
  z-index: 1000;
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-sizing: border-box;

  .left-section {
    display: flex;
    align-items: center;
  }

  .logo {
    width: 140px;
    padding-right: 24px;
    border-right: 1px solid #f0f0f0;
    img {
      height: 36px;
    }
  }

  .menu {
    margin-left: 24px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;

      li {
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-size: 14px;
        color: #595959;
        cursor: pointer;
        height: 64px;
        border-bottom: 2px solid transparent;

        i {
          margin-right: 6px;
          font-size: 16px;
        }

        &:hover {
          color: #1890ff;
          background: rgba(24,144,255,0.04);
        }

        &.active {
          color: #1890ff;
          border-bottom: 2px solid #1890ff;
          font-weight: 500;
        }
      }
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    gap: 24px;

    .notification {
      position: relative;
      
      .notification-icon {
        cursor: pointer;
        padding: 8px;
        border-radius: 4px;
        
        i {
          font-size: 20px;
          color: #595959;
        }
        
        &:hover {
          background: rgba(0,0,0,0.025);
        }
      }
    }
  }

  .user-info {
    .el-dropdown-link {
      display: flex;
      align-items: center;
      padding: 0 8px;
      height: 48px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background: rgba(0,0,0,0.025);
      }

      .username {
        margin: 0 8px;
        color: #262626;
        font-size: 14px;
      }

      .el-icon-arrow-down {
        color: #8c8c8c;
        font-size: 12px;
      }
    }
  }
}

:deep(.el-dropdown-menu__item) {
  i {
    margin-right: 8px;
  }
}

// 重新定义下拉菜单样式
.custom-notification-dropdown {
  width: 400px !important;
  padding: 0 !important;
  margin: 8px 0 !important;
  
  .notification-header {
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fafafa;
    
    span {
      font-size: 15px;
      font-weight: 500;
      color: #262626;
    }
    
    .el-button {
      padding: 0;
      height: auto;
      
      &:hover {
        color: #1890ff;
        background: transparent;
      }
    }
  }
  
  .notification-item {
    height: auto !important;
    line-height: 1.5 !important;
    padding: 16px 24px !important;
    margin: 0 !important;
    border-bottom: 1px solid #f5f5f5;
    
    &:hover {
      background: #f0f7ff !important;
    }
    
    &.unread {
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #1890ff;
      }
    }
    
    .notice-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding-left: 12px;
      
      i {
        font-size: 18px;
        margin-top: 2px;
        
        &.el-icon-document {
          color: #1890ff;
        }
        
        &.el-icon-setting {
          color: #52c41a;
        }
        
        &.el-icon-chat-dot-round {
          color: #722ed1;
        }
      }
      
      .notice-content {
        flex: 1;
        min-width: 0;
        
        .notice-title {
          color: #262626;
          margin-bottom: 6px;
          font-size: 14px;
          line-height: 1.5;
        }
        
        .notice-time {
          font-size: 12px;
          color: #8c8c8c;
        }
      }
    }
  }
  
  .notification-footer {
    padding: 12px 24px;
    text-align: center;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    
    .el-button {
      padding: 0;
      font-size: 13px;
      color: #595959;
      height: auto;
      
      &:hover {
        color: #1890ff;
        background: transparent;
      }
    }
  }
}

// 移除下拉菜单的箭头
:deep(.el-popper[x-placement^="bottom"]) {
  margin-top: 8px !important;
  
  .popper__arrow {
    display: none !important;
  }
}

// 优化徽标样式
:deep(.el-badge) {
  .el-badge__content {
    border: none !important;
    box-shadow: 0 0 0 1px #fff;
    height: 16px;
    min-width: 16px;
    line-height: 16px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: normal;
  }
}
</style> 